import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time",
  "use": "icon-time-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-time\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.7 64.2C265.5 64.2 65 264.7 65 511.9s200.4 447.7 447.7 447.7 447.7-200.4 447.7-447.7c-0.1-247.2-200.5-447.7-447.7-447.7z m214.4 590.6c-10.7 16.2-28.5 25-46.6 25-10.7 0-21.5-3.1-31-9.4L481.6 558.5c-15.6-10.4-24.9-27.9-24.9-46.6V232.1c0-30.9 25-56 56-56s56 25 56 56v249.8l143 95.3c25.6 17.2 32.6 51.9 15.4 77.6z m0 0\" fill=\"\" p-id=\"5573\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/time.svg
// module id = rB5f
// module chunks = 1